<template>
  <div class="gallery page">
    <ul class="image-gallery">
      <li v-for="(n, index) in 165" :key="index" class="image">
        <img class="img" :src="getImgUrl(n)" loading="lazy" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Gallery",
  methods: {
    getImgUrl(number) {
      var images = require.context("../assets/gallery/", false, /\.jpg$/);
      return images("./farzana-christopher-" + number + ".jpg");
    }
  }
};
</script>

<style lang="scss" scoped>
.gallery {
  display: flex;
  flex-direction: column;
}

.image-gallery {
  display: flex;
  flex-wrap: wrap;
}

.image {
  height: 40vh;
  flex-grow: 1;
}

.image:last-child {
  flex-grow: 10;
}

.img {
  max-height: 100%;
  min-width: 100%;
  object-fit: cover;
  vertical-align: bottom;
}

@media (max-aspect-ratio: 1/1) {
  .image {
    height: 30vh;
  }
}

@media (max-height: 480px) {
  .image {
    height: 80vh;
  }
}

@media (max-aspect-ratio: 1/1) and (max-width: 480px) {
  image-gallery {
    flex-direction: row;
  }

  .image {
    height: auto;
    width: 100%;
  }
  .img {
    width: 100%;
    max-height: 75vh;
    min-width: 0;
  }
}
</style>
